import "./Home.css"

export const Home = () => {
	return (
		<div className="Home">

		</div>
	)
}
